export const isEmpty = (obj: {[key: string]: any}) => {
  return !!Object.keys(obj || {}).length;
};

export const isValue = (value: any): boolean => {
  return typeof value !== 'undefined';
};

export const safeGet = (value: string, obj: {[key: string]: any}, notfoundObj?) => {
  const parts = value.split('.');
  return parts.reduce((xs, x) => (xs && isValue(xs[x])) ? xs[x] : notfoundObj, obj);
};

export const deepCopy = <T>(target: T): T => {
  if (!target) {
    return target;
  }

  if (target instanceof Date) {
    return new Date(target.getTime()) as any;
  }

  if (target instanceof Array) {
    const cp = [] as any[];
    (target as any[]).forEach((v) => { cp.push(v); });
    return cp.map((n: any) => deepCopy<any>(n)) as any;
  }

  if (typeof target === 'object' && Object.keys(target).length) {
    const cp = { ...(target as { [key: string]: any }) } as { [key: string]: any };
    Object.keys(cp).forEach(k => {
      cp[k] = deepCopy<any>(cp[k]);
    });
    return cp as T;
  }

  return target;
};

export const compareByField = (a, b, field: string) => {
    return safeGet(field, a) === safeGet(field, b);
};

export const compareById = (a, b) => {
  return compareByField(a, b, 'id');
};

export const compareByName = (a, b) => {
  return compareByField(a, b, 'name');
};

export const equals = (a, b): boolean => {
  return Object.entries(a).toString() === Object.entries(b).toString();
};
